import React, { Component } from 'react';
import numeral from 'numeral';
import { NULL } from 'constants/index';

interface IProps {
  value: number | string;
  format?: string;
  decimals?: number;
  className?: string;
}

class Numeric extends Component<IProps> {
  static defaultProps = {
    value: NULL,
    format: '0,0',
    decimals: 0,
    className: '',
  };

  addDecimals() {
    const { format, decimals } = this.props;
    if (!decimals) {
      return format;
    }

    const suffix = '0'.repeat(decimals);
    return format.concat(`.${suffix}`);
  }

  render() {
    const { value, className } = this.props;

    const withDecimals = this.addDecimals();
    const formattedValue = numeral(value).format(withDecimals);

    return <span className={className}>{formattedValue}</span>;
  }
}

export default Numeric;
